import { IUserLoginInfoModel } from "src/model";

export default class State
{
    /**
     * 获取或设置用户信息。
     * @member
     * @returns IUserLoginInfoModel
     */
    public profile: IUserLoginInfoModel;
}
